import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import Link from '../Atoms/Link';

import { FlyInText, OpacityWrapper } from '../Atoms/Animations';
import ArrowButton from '../Atoms/ArrowButton';
import PaymentGuaranteed from '../Atoms/Icons/PaymentGuaranteed';

type DoubleImageTextProps = {
  subtitle?: string;
  title?: string;
  description?: string;
  url?: string;
  imageLeft?: object;
  imageRight?: object;
  imagesOnTheLeft?: boolean;
  textWrapperClass?: string;
  titleClass?: string;
}

const imageQuery = graphql`
query {
  image1: file(base: {eq: "image1.jpg"}) {
    childImageSharp {
      gatsbyImageData(
        width: 447,
        layout: FULL_WIDTH,
        placeholder: DOMINANT_COLOR
      )
    }
  }
  grafica: file(base: {eq: "grafica.jpg"}) {
    childImageSharp {
      gatsbyImageData(
        width: 330,
        layout: FULL_WIDTH,
        placeholder: DOMINANT_COLOR
      )
    }
  }
}
`;

const DoubleImageText = ({
  subtitle = 'doubleImageText.subtitle',
  title = 'doubleImageText.title',
  description = 'doubleImageText.text',
  url = 'doubleImageText.url',
  imageLeft = {},
  imageRight = {},
  imagesOnTheLeft = true,
  textWrapperClass = '',
  titleClass = '',
}: DoubleImageTextProps) => {
  const { t } = useTranslation();
  const { image1, grafica } = useStaticQuery(imageQuery);

  return (
    <section className="py-12 px-4 lg:px-8 flex flex-row relative">
      <div className={`max-w-screen-2xl w-full mx-auto flex ${imagesOnTheLeft ? 'flex-col lg:flex-row' : 'flex-col lg:flex-row-reverse' }`}>
        <div className="absolute bottom-72 -right-2 lg:static lg:w-1/12 mr-6 order-3 lg:order-1">
          <PaymentGuaranteed className="w-18 h-18 lg:w-24 lg:h-24" />
        </div>
        <div className="h-80 lg:h-auto mt-14 lg:mt-0 lg:w-5/12 relative order-2">
          <GatsbyImage image={getImage(imageLeft) || getImage(image1)} alt="watches" objectFit='contain' className="w-64 lg:w-4/5 lg:!absolute top-0" />
          <GatsbyImage image={getImage(imageRight) || getImage(grafica)} alt="diagram" className="w-44 lg:w-3/5 !absolute top-48 lg:top-112 right-0" />
        </div>
        <div className="lg:w-1/12 lg:block hidden lg:order-3" />
        <OpacityWrapper className={`lg:w-4/12 px-3 lg:pt-24 order-1 lg:order-4 ${textWrapperClass}`}>
          <FlyInText tag="p" className="font-cirka text-xl mb-5">{t(subtitle)}</FlyInText>
          <FlyInText tag="h2" y="40px" className={`font-cirka text-primary text-3xl lg:text-5xl mb-8 lg:mb-16 ${titleClass}`}>{t(title)}</FlyInText>
          <FlyInText tag="p" y="80px" className="font-light mb-16" dangerouslySetInnerHTML={{ __html: t(description) }} />
          <Link to={t(url)} className="no-animation">
            <ArrowButton isGhost={false} />
          </Link>
        </OpacityWrapper>
        <div className="lg:order-5 lg:w-1/12 lg:block hidden" />
      </div>
    </section>
  );
}

export default DoubleImageText;
